import React from 'react';
import PropTypes from "prop-types";
import { dynamicPrice, normalizeISO } from '@common/helpers/helperFunctions';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import Config from '@skin_config';
import DateCountdown from '@app/dev/terminal/components/dateCountdown';
import { TournamentStageEnum, TournamentStageViewEnum } from '@app/dev/constants/enums/tournament';
import classNames from 'classnames';
import { restrictForLoggedIn } from '../helpers';
import {useTranslation} from "@common/hooks/translation";
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

const TournamentListItem = ({ tournament }) => {
    const t = useTranslation();
    const navigate = useNavigate()
    const bannerImage = tournament.DetailsBannerImages[0]?.Images[0]?.ImageUrl;
    const lobbyImage = tournament.LobbyBannerImages[0]?.Images[0]?.ImageUrl;

    const joinTournament = restrictForLoggedIn(async () => {
        const result = await swarmRequest({ tournament_id: tournament.Id }, 'join_to_tournament');
        console.log(result);
    });

    const viewTournament = () => {
        navigate(`/tournaments/${tournament.Id}`);
    }

    const statusClassName = classNames({
        'live-status': tournament.Stage === TournamentStageEnum.Live,
        'finished-status': tournament.Stage === TournamentStageEnum.Finished,
    });

    return <div className="tournament-list-item" style={{ backgroundImage: `url(${bannerImage})` }}>
        <div>
            {lobbyImage && <div className="lobby-image" style={{ backgroundImage: `url(${lobbyImage})` }} />}
            <div className="tournament-info">
                <h2 className="tournament-info-title">{tournament.Name}</h2>
                <h3 className="prize-fund">{dynamicPrice(Config, tournament.PrizeFund, tournament.CurrencyId)}</h3>

                {tournament.Stage === TournamentStageEnum.Live
                    ? <DateCountdown seconds={(moment(normalizeISO(tournament.EndDate)) - moment()) / 1000} />
                    : <h3>{t(TournamentStageViewEnum[tournament.Stage])}</h3>}

                <p className="tournament-status">
                    {t('Status')}:
                    <span className={statusClassName}>{t(TournamentStageViewEnum[tournament.Stage])}</span>
                </p>
            </div>

            <div className="tournament-content">
                <div className="tournament-date-block">
                    <h3>{t('Registration Date')}</h3>
                    <div className="tournament-date-inner">
                        <div className="tournament-date-inner-row">
                            <h5>{t('Start')}</h5>
                            <p>{moment(normalizeISO(tournament.RegistrationStartDate)).format(Config.main.dateTimeFormat)}</p>
                        </div>
                        <div className="tournament-date-inner-row">
                            <h5>{t('End')}</h5>
                            <p>{moment(normalizeISO(tournament.RegistrationEndDate)).format(Config.main.dateTimeFormat)}</p>
                        </div>
                    </div>
                </div>

                <div className="tournament-date-block">
                    <h3>{t('Tournament Date')}</h3>
                    <div className="tournament-date-inner">
                        <div className="tournament-date-inner-row">
                            <h5>{t('Start')}</h5>
                            <p>{moment(normalizeISO(tournament.StartDate)).format(Config.main.dateTimeFormat)}</p>
                        </div>
                        <div className="tournament-date-inner-row">
                            <h5>{t('End')}</h5>
                            <p>{moment(normalizeISO(tournament.EndDate)).format(Config.main.dateTimeFormat)}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tournament-actions">
                <button className="tournament-but" onClick={viewTournament}>{t("View")}</button>
                <button className="tournament-but join" disabled={!tournament.IsJoinable || tournament.JoinDate} onClick={joinTournament}>
                    {tournament.JoinDate ? t('Joined') : t("Join")}
                </button>
            </div>
        </div>
    </div>
};

TournamentListItem.propTypes = {
    tournament: PropTypes.object.isRequired,
};

export default TournamentListItem;